import { alpha, styled } from '@mui/material'
import SplitButton from './SplitButton'

const HeaderSplitButton = styled(SplitButton)(({ variant, theme, size }) => ({
  '& .MuiButton-root:last-child': {
    padding: 0,
    minWidth: size === 'small' ? theme.spacing(3) : size === 'large' ? theme.spacing(6) : theme.spacing(4)
  },

  ...(variant === 'outlined' && {
    '& .MuiButtonGroup-firstButton': {
      borderRightColor: 'transparent !important'
    },
    '& .MuiButtonBase-root': {
      borderColor: alpha(theme.palette.brand.appBarContrastText, 0.4),
      '& .MuiTypography-root': {
        color: theme.palette.brand.appBarContrastText
      },

      '&:disabled': {
        '& .MuiTypography-root': {
          color: alpha(theme.palette.brand.appBarContrastText, 0.2)
        },
        border: `1px solid ${alpha(theme.palette.brand.appBarContrastText, 0.2)}`,
        svg: {
          color: alpha(theme.palette.brand.appBarContrastText, 0.2)
        }
      },
      svg: {
        color: theme.palette.brand.appBarContrastText
      },
      '&:hover, &:active': {
        border: `1px solid ${alpha(theme.palette.brand.appBarContrastText, 0.4)}`,
        backgroundColor: alpha(theme.palette.brand.appBarContrastText, 0.12)
      }
    }
  }),
  ...(variant === 'contained' && {
    '& .MuiButtonGroup-firstButton': {
      '&: disabled': {
        borderRightColor: 'transparent !important'
      }
    },
    '& .MuiButton-root': {
      '& .MuiTypography-root': {
        color: theme.palette.brand.appBarContrastText
      },
      '&:disabled': {
        color: alpha(theme.palette.brand.appBarContrastText, 0.25),
        border: `1px solid ${alpha(theme.palette.brand.appBarContrastText, 0.25)}`,
        backgroundColor: 'rgba(0,0,0,0)',

        '& .MuiTypography-root': {
          color: alpha(theme.palette.brand.appBarContrastText, 0.25)
        },
        svg: {
          color: alpha(theme.palette.brand.appBarContrastText, 0.25)
        }
      },
      svg: {
        color: theme.palette.brand.appBarContrastText
      }
    }
  })
}))

export default HeaderSplitButton
